import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [LIST_PROJECTS, LIST_PROJECTS_SUCCESS, LIST_PROJECTS_FAILURE] =
  createRequestActionTypes('tech/LIST_PROJECTS');
export const listProjects = createAction(
  LIST_PROJECTS,
  (searchData) => searchData,
);
const listProjectsSaga = createRequestSaga(
  LIST_PROJECTS,
  techApi.getTechProjects
);

const UNLOAD_TECHPROJECTS = 'tech/UNLOAD_TECHPROJECTS';
export const unloadTechProjects = createAction(UNLOAD_TECHPROJECTS);

export function* projectsSaga() {
  yield takeLatest(LIST_PROJECTS, listProjectsSaga);
}

const initialState = {
  projects: null,
  error: null,
};

const projects = handleActions(
  {
    [LIST_PROJECTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      projects: data.list.map((project) => ({
        id: project.prjUuid,
        prjSeq: project.prjSeq,
        prjUuid: project.prjUuid,
        prjNo: project.prjNo,
        techGrade: project.techGrade,
        techStatus: project.techStatus,
        cstNm: project.cstNm,
        partnerInc: project.partnerInc,
        crtDptNm: project.crtDptNm,
        crtNm: project.crtNm,
        crtGradeNm: project.crtGradeNm,
        totalPurchase: project?.totalPurchase,
        totalSales: project?.totalSales,
        totalProfit: project?.totalProfit,
        totalMargin: project?.totalMargin,
        crtDt: project.crtDt,
        cngNm: project.cngNm,
        cngDt: project.cngDt,
      })),
      error: null,
    }),
    [LIST_PROJECTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_TECHPROJECTS]: () => initialState,
  },
  initialState,
);

export default projects;
